<template lang="pug">
  .login-page.login-form-block.guest-forms

    template(v-if="isTokenChecking")
      .panel.panel-default.panel-login.panel-login--token
        div
          circle-loader(size="3.4rem")
            .circle-loader--body
              .token-checking-title {{ $t('Проверяем токен аутентификации...') }}
    template(v-if="isTokenRedirecting || isNoTokenRedirecting")
      .panel.panel-default.panel-login.panel-login--token
        div
          circle-loader(size="5rem")
            div.circle-loader--body
              span.redirection-url-prefix {{ $t('Сейчас вы будете перенаправлены на страницу') }}:
              a(:href="checkTokenModel.redirectingUrl").redirection-url {{ checkTokenModel.redirectingUrl }}
          div.panel-login--token--footer
            div.hint {{$t('Если это не произошло автоматически, пройдите вручную:')}}
            a(:href="checkTokenModel.redirectingUrl").btn.btn-success.btn-success-outline {{ $t('Перейти') }}
    template(v-if="!isTokenChecking && !isTokenRedirecting")
      .panel.panel-default.panel-login
        .panel-heading
          ul
            li.active
              a(href='/login') {{ $t('Вход') }}
            li
              a(href='/reg') {{ $t('Регистрация') }}
        .panel-body
          login-form(ref="loginForm" :disabled="isDisabled"
            :oauth="oauth"
            @login-start="onLoginStarted"
            @login-fail="onLoginFail"
            @login-2fa-fail="onLoginFail"
            @login-end="onLoginEnded"
            @login-success="onLoginSuccess"
            @login-2fa-start="onLogin2FaStarted"
            @login-2fa-submit="onLoginStarted"
            @password-press-enter="onPasswordPressEnter"
            @2fa-press-enter="onPasswordPressEnter")
            template(v-slot:after="slotProps")
              template(v-if="!slotProps.googleCodeMode")
                .login-buttons-row
                  .lbr-col
                    a.link(href='/remember' :aria-disabled="isDisabled") {{$t('Восстановить пароль')}}
                  .lbr-col
                    button.btn.btn-success(type='button' :disabled="isDisabled" @click='submit')
                      template(v-if="isDisabled")
                        circle-loader(size="12px") {{$t('Входим...')}}
                      template(v-if="!isDisabled") {{$t('Войти')}}
              template(v-if="slotProps.googleCodeMode")
                .login-buttons-row
                  .lbr-col
                    button.btn.btn-success-outline(type='button' :disabled="isDisabled" @click='cancel') {{$t('Отмена')}}
                  .lbr-col
                    button.btn.btn-success(type='button' :disabled="isDisabled" @click='submit')
                      template(v-if="isDisabled")
                        circle-loader(size="12px") {{$t('Входим...')}}
                      template(v-if="!isDisabled") {{$t('Войти')}}
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import LoginForm from '@/views/pages/auth/login/LoginForm.vue';
import {RemoteRequestState} from '@/backoffice/components/pages/taxrules/taxrules';
import AuthModel from '@/core/auth/AuthModel';
import {AuthResults, CheckAuthTokenModel} from '@/core/auth/Auth';
import CircleLoader from '@/components/loaders/CircleLoader.vue';

@Component({
  name: 'login-form-block',
  components: {CircleLoader, LoginForm},
})
export default class LoginFormBlock extends Vue {
  @Prop({default: false})
  disabled!: boolean

  @Prop({default: false})
  oauth: boolean

  @Prop({default: false})
  autologin: boolean

  @Prop({default: ''})
  backurl: string | null

  submitStatus = new RemoteRequestState();

  checkTokenModel = new CheckAuthTokenModel();

  @Prop({default: false})
  disableRedirect: boolean

  mounted() {
    this.checkTokenModel.debugDisableRedirect = this.disableRedirect;
    if ((this.oauth && this.backurl) || this.autologin) {
      this.checkTokenModel.checkToken().then(({oauth_token, backUrl}) => {
        this.checkTokenModel.redirectWithToken(
          (this.backurl ? this.backurl : backUrl),
          this.oauth ? oauth_token : null);
      });
    }
  }

  get isTokenRedirecting() {
    return (!this.autologin && this.oauth) && (this.checkTokenModel.redirectingUrl ? true : false);
  }

  // get isNotokenRedirecting() {
  //   return !this.oauth && (this.checkTokenModel.redirectingUrl ? true : false);
  // }

  get isTokenChecking() {
    return this.checkTokenModel.checkingStatus.isLoading;
  }

  get isNoTokenRedirecting() {
    return this.autologin && (this.checkTokenModel.redirectingUrl ? true : false);
  }

  onPasswordPressEnter() {
    this.submit();
  }

  forceDisable = false;

  get busyModel(): boolean {
    return this.submitStatus.isLoading;
  }


  onLogin2FaStarted(model: AuthModel) {
    this.forceDisable = false;
    this.submitStatus.loadEnd();
  }

  onLoginStarted(model: AuthModel) {
    this.forceDisable = true;
    this.submitStatus.loadStart();
  }

  onLoginEnded(model: AuthModel) {
    return null;
  }

  onLoginFail(model: AuthModel) {
    this.forceDisable = false;
    this.submitStatus.loadError();
  }

  onLoginSuccess(model: AuthModel, result: AuthResults) {
    // console.log('onLoginSuccess', model, result);

    const oauthToken = result.getOauthToken();
    if (this.oauth && this.backurl) {
      this.checkTokenModel.redirectWithToken(this.backurl, oauthToken);
      return;
    }


    let returnUrl = '';
    try {
      returnUrl = `${result!.getResponseData().returnUrl}` as string;
    } catch (err) {
      returnUrl = '/finance';
    }
    this.checkTokenModel.redirectWithToken(returnUrl);
  }

  get isDisabled(): boolean {
    return this.busyModel || this.disabled || this.forceDisable;
  }

  cancel() {
    (this.$refs.loginForm as LoginForm).cancel();
  }

  submit() {
    (this.$refs.loginForm as LoginForm).submit();
  }
}
</script>

<style scoped lang="less">
.panel-login {
  border-radius: 0.6rem;
}
.login-form-block {
  ::v-deep {

  }
}

.panel-login--token {
  padding: 5rem 5rem;
  .redirection-url {
    word-break: break-word;
    // font-size: 1.1rem;
  }
  .redirection-url-prefix {
    margin-right: 1ex;
    font-weight: bolder;
  }
  .panel-login--token--footer {
    padding-top: 4rem;
    display: flex;
    gap: 2rem;
    align-items: center;
    justify-content: center;
    .hint {
      font-size: 1.4rem;
    }
  }
  .token-checking-title {
    font-size: 2rem;
  }
  .circle-loader--body {
    padding-left: 2ex;
  }
}
.panel + .panel {
  margin-top: 2rem;
}
</style>

<i18n>
{
  "en": {
    "Вход": "Log in",
    "Войти": "Log in",
    "Восстановить пароль": "Remember password",
    "Регистрация": "Registration",
    "Входим...": "Logging in...",
    "Проверить код и войти": "Log in",
    "Отмена": "Cancel",
    "Перейти": "Go to",
    "Проверяем токен аутентификации...": "Checking authentication token...",
    "Сейчас вы будете перенаправлены на страницу": "You will be redirected to the page",
    "Проверяем токен...": "Checking token...",
    "Если это не произошло автоматически, пройдите вручную:": "If this did not happen automatically, go manually:"
  }
}
</i18n>
